import styled from 'styled-components'
import { Card, Modal } from 'react-bootstrap'

export const ChartContainer = styled(Card)`
  background: #212529;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const ChartHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`

export const ChartTitle = styled.h6`
  color: #ffffff;
  margin: 0;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const FlowContainer = styled.div`
  flex: 1;
  width: 100%;
  background: #1a1a1a;
  border-radius: 0 0 0.5rem 0.5rem;
  min-height: 450px;

  /* Override ReactFlow cursor in lasso mode */
  &.lasso-mode .react-flow,
  &.lasso-mode .react-flow__pane,
  &.lasso-mode .react-flow__renderer {
    cursor: crosshair !important;
  }
`

export const GenerateButton = styled.button`
  background: linear-gradient(45deg, #402563, #114ee0);
  border: none;
  padding: 0.5rem 1rem;
  font-weight: 500;
  transition: all 0.2s ease;
  border-radius: 0.375rem;
  color: #ffffff;
  cursor: pointer;
  font-size: 0.875rem;

  &:hover:not(:disabled) {
    background: linear-gradient(45deg, #4e2d7c, #1757e8);
    transform: translateY(-1px);
  }

  &:disabled {
    background: #343a40;
    opacity: 0.7;
    cursor: not-allowed;
  }
`

export const LoadingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: #ffffff;
  gap: 1rem;
`

export const ContentViewerModal = styled(Modal)`
  .modal-dialog {
    max-width: 90vw;
    margin: 1rem auto;
  }

  .modal-content {
    background: #212529;
    border: 1px solid rgba(255, 255, 255, 0.2);
    color: #ffffff;
  }

  .modal-header {
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .modal-body {
    max-height: 70vh;
    overflow-y: auto;
  }
`

export const ContentGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
  padding: 1rem 0;
`

export const ContentItem = styled.div`
  background: #1a1a1a;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 0.5rem;
  padding: 1rem;
  transition: all 0.2s ease;

  &:hover {
    border-color: rgba(255, 255, 255, 0.3);
    transform: translateY(-2px);
  }
`

export const ContentImage = styled.img`
  width: 100%;
  height: 120px;
  object-fit: contain;
  border-radius: 0.25rem;
  margin-bottom: 0.5rem;
  background: #000000;
`

export const ContentInfo = styled.div`
  font-size: 0.875rem;

  .content-name {
    font-weight: 600;
    margin-bottom: 0.5rem;
    color: #ffffff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .content-details {
    color: #adb5bd;
    font-size: 0.75rem;
    margin-bottom: 0.5rem;
  }

  .annotation-status {
    display: inline-block;
    padding: 0.125rem 0.5rem;
    border-radius: 0.25rem;
    font-size: 0.7rem;
    font-weight: 500;
  }

  .annotated {
    background: rgba(40, 167, 69, 0.2);
    color: #28a745;
    border: 1px solid rgba(40, 167, 69, 0.3);
  }

  .unannotated {
    background: rgba(17, 78, 224, 0.2);
    color: #114ee0;
    border: 1px solid rgba(17, 78, 224, 0.3);
  }
`

export const ButtonOverlay = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  z-index: 1100;
  max-width: 80vw;
  flex-wrap: wrap;
  justify-content: flex-end;
  align-items: flex-start;

  .button-row {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    flex-wrap: wrap;
  }

  .dropdown-toggle,
  .btn {
    font-size: 0.75rem !important;
    padding: 0.5rem 0.8rem !important;
    white-space: nowrap;
    backdrop-filter: blur(12px);
    background: linear-gradient(135deg, rgba(45, 55, 72, 0.95), rgba(33, 37, 41, 0.95)) !important;
    border: 1px solid rgba(255, 255, 255, 0.15) !important;
    color: #ffffff !important;
    border-radius: 0.5rem !important;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1) !important;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
    font-weight: 500 !important;
    letter-spacing: 0.025em;
    position: relative;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
      transition: left 0.5s ease;
    }

    &:hover {
      background: linear-gradient(
        135deg,
        rgba(52, 58, 64, 0.95),
        rgba(45, 55, 72, 0.95)
      ) !important;
      border-color: rgba(255, 255, 255, 0.25) !important;
      transform: translateY(-1px) !important;
      box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2), 0 4px 8px rgba(0, 0, 0, 0.15) !important;

      &::before {
        left: 100%;
      }
    }

    &:active {
      transform: translateY(0) !important;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
    }

    &.btn-warning {
      background: linear-gradient(
        135deg,
        rgba(251, 191, 36, 0.95),
        rgba(245, 158, 11, 0.95)
      ) !important;
      color: #1a1a1a !important;
      border-color: rgba(251, 191, 36, 0.4) !important;
      font-weight: 600 !important;

      &:hover {
        background: linear-gradient(
          135deg,
          rgba(251, 191, 36, 1),
          rgba(245, 158, 11, 1)
        ) !important;
        border-color: rgba(251, 191, 36, 0.6) !important;
        box-shadow: 0 6px 20px rgba(251, 191, 36, 0.3), 0 4px 8px rgba(0, 0, 0, 0.15) !important;
      }
    }

    &.btn-outline-primary {
      background: linear-gradient(
        135deg,
        rgba(17, 78, 224, 0.25),
        rgba(29, 78, 216, 0.25)
      ) !important;
      color: #60a5fa !important;
      border-color: rgba(17, 78, 224, 0.4) !important;

      &:hover {
        background: linear-gradient(
          135deg,
          rgba(17, 78, 224, 0.4),
          rgba(29, 78, 216, 0.4)
        ) !important;
        color: #93c5fd !important;
        border-color: rgba(17, 78, 224, 0.6) !important;
        box-shadow: 0 6px 20px rgba(17, 78, 224, 0.25), 0 4px 8px rgba(0, 0, 0, 0.15) !important;
      }
    }

    &.btn-outline-warning {
      background: linear-gradient(
        135deg,
        rgba(251, 191, 36, 0.25),
        rgba(245, 158, 11, 0.25)
      ) !important;
      color: #fbbf24 !important;
      border-color: rgba(251, 191, 36, 0.4) !important;

      &:hover {
        background: linear-gradient(
          135deg,
          rgba(251, 191, 36, 0.4),
          rgba(245, 158, 11, 0.4)
        ) !important;
        color: #fcd34d !important;
        border-color: rgba(251, 191, 36, 0.6) !important;
        box-shadow: 0 6px 20px rgba(251, 191, 36, 0.25), 0 4px 8px rgba(0, 0, 0, 0.15) !important;
      }
    }

    &.btn-outline-danger {
      background: linear-gradient(
        135deg,
        rgba(220, 53, 69, 0.25),
        rgba(239, 68, 68, 0.25)
      ) !important;
      color: #f87171 !important;
      border-color: rgba(220, 53, 69, 0.4) !important;

      &:hover {
        background: linear-gradient(
          135deg,
          rgba(220, 53, 69, 0.4),
          rgba(239, 68, 68, 0.4)
        ) !important;
        color: #fca5a5 !important;
        border-color: rgba(220, 53, 69, 0.6) !important;
        box-shadow: 0 6px 20px rgba(220, 53, 69, 0.25), 0 4px 8px rgba(0, 0, 0, 0.15) !important;
      }
    }
  }

  .selected-count {
    color: #fbbf24;
    font-size: 0.75rem;
    font-weight: 600;
    background: linear-gradient(135deg, rgba(0, 0, 0, 0.8), rgba(17, 24, 39, 0.8));
    padding: 0.4rem 0.8rem;
    border-radius: 0.5rem;
    backdrop-filter: blur(12px);
    border: 1px solid rgba(251, 191, 36, 0.3);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    letter-spacing: 0.025em;
  }

  .selected-count {
    color: #fbbf24;
    font-size: 0.75rem;
    font-weight: 500;
    background: rgba(0, 0, 0, 0.7);
    padding: 0.25rem 0.5rem;
    border-radius: 0.25rem;
    backdrop-filter: blur(4px);
  }
`

export const Legend = styled.div<{ $expanded?: boolean }>`
  position: absolute;
  top: 10px;
  left: 10px;
  background: rgba(0, 0, 0, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.5rem;
  padding: 0.75rem;
  font-size: 0.75rem;
  color: #ffffff;
  z-index: 10;
  ${(props) =>
    props.$expanded
      ? `
    max-width: 80vw;
    width: max-content;
    max-height: 300px;
  `
      : `
    max-width: 200px;
    max-height: 70vh;
  `}
  overflow-y: auto;

  /* Custom scrollbar styling */
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.3);
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
  }
`

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.25rem;

  &:last-child {
    margin-bottom: 0;
  }
`

export const LegendItemsContainer = styled.div<{ $expanded?: boolean }>`
  ${(props) =>
    props.$expanded
      ? `
    display: grid;
    grid-template-columns: repeat(6, minmax(120px, 1fr));
    gap: 0.15rem 0.5rem;
    width: 100%;
    
    & > div {
      margin-bottom: 0;
      font-size: 0.7rem;
    }
  `
      : `
    display: block;
  `}
`

export const LegendColor = styled.div<{ color: string }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${(props) => props.color};
  margin-right: 0.5rem;
  border: 1px solid rgba(255, 255, 255, 0.3);
`

// Stats Card styled components
export const StatsCard = styled(Card)`
  background: #212529;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 0.5rem;
  height: 100%;
  display: flex;
  flex-direction: column;
`

export const StatsHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
`

export const StatsTitle = styled.h6`
  color: #ffffff;
  margin: 0;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const StatsContent = styled.div`
  padding: 1rem;
  color: #ffffff;
  flex: 1;
  display: flex;
  flex-direction: column;
`

export const StatsSection = styled.div`
  margin-bottom: 1.5rem;

  &:last-child {
    margin-bottom: 0;
  }
`

export const SectionTitle = styled.div`
  font-size: 0.9rem;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.75rem;
  margin-bottom: 1rem;

  @media (max-width: 1400px) {
    grid-template-columns: 1fr;
    gap: 0.5rem;
  }
`

export const CompactStatItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.5rem 0.75rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 0.375rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
`

export const CompactStatLabel = styled.span`
  color: #adb5bd;
  font-size: 0.8rem;
  font-weight: 500;
`

export const CompactStatValue = styled.span`
  color: #ffffff;
  font-weight: 600;
  font-size: 0.9rem;
`

export const StatItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.75rem 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  &:last-child {
    border-bottom: none;
  }
`

export const StatLabel = styled.span`
  color: #adb5bd;
  font-size: 0.875rem;
`

export const StatValue = styled.span`
  color: #ffffff;
  font-weight: 600;
  font-size: 1rem;
`

export const StatBadge = styled.span<{
  variant?: 'success' | 'warning' | 'info' | 'danger'
}>`
  display: inline-block;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-size: 0.75rem;
  font-weight: 500;

  ${(props) => {
    switch (props.variant) {
      case 'success':
        return `
          background: rgba(40, 167, 69, 0.2);
          color: #28a745;
          border: 1px solid rgba(40, 167, 69, 0.3);
        `
      case 'warning':
        return `
          background: rgba(255, 193, 7, 0.2);
          color: #ffc107;
          border: 1px solid rgba(255, 193, 7, 0.3);
        `
      case 'info':
        return `
          background: rgba(17, 78, 224, 0.2);
          color: #114ee0;
          border: 1px solid rgba(17, 78, 224, 0.3);
        `
      case 'danger':
        return `
          background: rgba(220, 53, 69, 0.2);
          color: #dc3545;
          border: 1px solid rgba(220, 53, 69, 0.3);
        `
      default:
        return `
          background: rgba(108, 117, 125, 0.2);
          color: #6c757d;
          border: 1px solid rgba(108, 117, 125, 0.3);
        `
    }
  }}
`

export const ScrollableContainer = styled.div`
  max-height: 200px;
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */

  /* Hide scrollbar for Chrome, Safari and Opera */
  &::-webkit-scrollbar {
    display: none;
  }
`
